import axios from 'axios';

export default function (injection, Vue) {

    let config = {
        responseOkInterceptors: undefined,
        errorCallbacks: {'401': () => {}},
        beforeApiGateway: (api, data, apiFunc, config) => {},
        fixedApi: api => api,
        fixedOptions: config => {
            return {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        },
        ready: (Vue, config) => {},
        plugins: {},
        extra: {}
    };

    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    axios.interceptors.response.use(response => {
        const interceptors = config.responseOkInterceptors;
        if (interceptors) {
            if (interceptors instanceof Array) {
                interceptors.forEach(func => {
                    response = func(response);
                });
            } else if (typeof interceptors === 'function') {
                response = interceptors(response);
            }
        }
        return response;
    }, error => {
        if (!error.response) {
            return Promise.reject({
                errcode: 999999,
                error: error,
                errmessage: '网络异常',
            });
        }
        const statusCode = error.response.status;
        const errorData = error.response.data;
        decJobs();
        const statusCodeErrorCallback = config.errorCallbacks[statusCode];
        if (statusCodeErrorCallback) {
            return statusCodeErrorCallback(error);
        }
        if (errorData) {
            return Promise.reject(errorData);
        }
        return Promise.reject({
            errcode: statusCode,
            errmessage: error.message
        });
    });

    const triggerMap = {};
    const presets = {};

    let _loadingDom = null;
    let _jobsCount = 0;

    const makeLoadingDom = function () {
        _loadingDom = document.createElement('div');
        _loadingDom.className = 'global-http-loading';
        document.body.appendChild(_loadingDom);
        _loadingDom.addEventListener('transitionend', function () {
            if (_loadingDom.style.width === '100%') {
                _loadingDom.style.display = 'none';
                _loadingDom.style.width = 0;
                setTimeout(() => {
                    _loadingDom.style.display = 'block';
                    _loadingDom.style.transition = 'width .2s ease';
                }, 0);
            }
        });
    };

    const incJobs = function () {
        _jobsCount += 1;
        _loadingDom.style.width = '90%';
    };

    const decJobs = function () {
        if (_jobsCount > 0) {
            _jobsCount -= 1;
        }

        if (_jobsCount === 0) {
            _loadingDom.style.width = '100%';
            // _loadingDom.style.transition = 'unset';
            // setTimeout(() => {
            //     _loadingDom.style.display = 'none';
            //     _loadingDom.style.width = 0;
            //     setTimeout(() => {
            //         _loadingDom.style.display = 'block';
            //         _loadingDom.style.transition = 'width .2s ease';
            //     }, 100);
            // }, 100);
        }
    };

    const apiGateway = function (api, data) {
        if (config.beforeApiGateway) {
            const result = config.beforeApiGateway(api, data, apiFunc, config);
            if (result) {
                return result;
            }
        }
        return apiFunc.apply(apiGateway, arguments);
    };

    const apiFunc = function (api, data, options = {}) {
        api = config.fixedApi(api, data, options);
        const tgOptions = config.fixedOptions(config);
        const fixedData = modifyArguments(data);
        tgOptions.url = api;
        tgOptions.data = mergeData(tgOptions.data, fixedData);
        Object.keys(options).forEach(x => {
            tgOptions[x] = options[x];
        });
        if (process.env.NODE_ENV === 'production') {
            if (window._CONFIG && window._CONFIG.CSRF) {
                tgOptions.headers['X-CSRF-TOKEN'] = window._CONFIG.CSRF;
            } else if (window._CSRF) {
                tgOptions.headers['X-CSRF-TOKEN'] = window._CSRF;
            }
        }
        if (tgOptions.method.toLocaleLowerCase() === 'get') {
            tgOptions['params'] = tgOptions['data'];
        }
        incJobs();
        return axios.request(tgOptions).then(function (response) {
            // return axios.post('/api/' + api, data).then(function (response) {
            decJobs();
            if (typeof response.data === 'string' && response.data.toLowerCase() === 'ok' && response.status === 200) {
                return Promise.resolve(response.data);
            }
            if (!response) {
                return Promise.reject({
                    errcode: 500
                });
            }
            if (!('data' in response)) {
                return Promise.reject({
                    errcode: 500
                });
            }
            if (('errcode' in response.data) && response.data.errcode >= 400) {
                if (response.data.errcode === 40001 || response.data.errcode === 401) {
                    return config.errorCallbacks[401]();
                }
                return Promise.reject(response.data);
            } else {
                if (response.data && 'trigger' in response.data) {
                    if (response.data.trigger in triggerMap) {
                        triggerMap[response.data.trigger].forEach((x) => {
                            x.call(apiGateway, response.data.data, api, data);
                        });
                    }
                }
                if ('errcode' in response.data) {
                    if (response.data.errcode !== 0) {
                        return Promise.reject(response.data);
                    }
                    return Promise.resolve(response.data.data);
                } else {
                    return Promise.resolve(response.data);
                }
            }
        }).catch(error => {
            decJobs();
            return Promise.reject(error);
        });
    };

    const mergeData = function (defaultData, data) {
        if (!defaultData) {
            return data;
        }
        if (data instanceof FormData) {
            Object.keys(defaultData).forEach((x) => {
                if (!data.has(x)) {
                    data.append(x, defaultData[x]);
                }
            });
        } else {
            data = Object.assign(injection.util.deepCopy(defaultData), data);
        }
        return data;
    };

    const modifyArguments = function (data) {
        if (!(data instanceof Object)) {
            return data;
        }
        if (data instanceof FormData) {
            Object.keys(presets).forEach((x) => {
                if (!data.has(x)) {
                    data.append(x, presets[x]);
                }
            });
        } else {
            data = Object.assign(injection.util.deepCopy(presets), data);
        }
        let hasFile = false;
        Object.keys(data).forEach((x) => {
            if (data[x] instanceof window.File) {
                hasFile = true;
            } else if (data[x] instanceof window.Blob) {
                hasFile = true;
            }
        });
        if (hasFile) {
            let formData = new FormData();
            Object.keys(data).forEach((x) => {
                formData.append(x, data[x]);
            });
            return formData;
        }
        return data;
    };

    apiGateway.setTrigger = function (trigger, func) {
        if (trigger in triggerMap) {
            triggerMap[trigger].push(func);
        } else {
            triggerMap[trigger] = [func];
        }
        return apiGateway;
    };

    apiGateway.preset = function (key, value) {
        presets[key] = value;
    };

    apiGateway.install = function (key, func) {
        apiGateway[key] = func.bind(apiGateway);
    };

    apiGateway.setConfig = function (conf) {
        Object.keys(conf).forEach(v => {
            config[v] = conf[v];
        });
        Object.keys(config.plugins).forEach(v => {
            apiGateway.install(v, config.plugins[v]);
        });
        config.ready(Vue, config);
    };

    apiGateway.getConfig = function () {
        return config;
    };

    makeLoadingDom();

    axios.jsonp = (url, data) => {
        if (!url) {
            throw new Error('url is necessary');
        }
        let callback = 'CALLBACK' + Math.random().toString().substr(9, 18);
        if (data.callback) {
            callback = data.callback;
            delete data.callback;
        }
        const JSONP = document.createElement('script');
        JSONP.setAttribute('type', 'text/javascript');

        const headEle = document.getElementsByTagName('head')[0];

        let ret = '';
        if (data) {
            if (typeof data === 'string')
                ret = '&' + data;
            else if (typeof data === 'object') {
                for (let key in data)
                    ret += '&' + key + '=' + encodeURIComponent(data[key]);
            }
            ret += '&_time=' + Date.now();
        }
        JSONP.src = `${url}?callback=${callback}${ret}`;
        return new Promise((resolve, reject) => {
            window[callback] = r => {
                resolve(r);
                headEle.removeChild(JSONP);
                delete window[callback];
            };
            JSONP.onerror = ($e) => {
                reject($e);
            };
            headEle.appendChild(JSONP);
        });

    };

    Object.defineProperties(Vue.prototype, {
        $api: {
            get () {
                return apiGateway;
            }
        },
        $http: {
            get () {
                return axios;
            }
        }
    });

    Object.defineProperties(injection, {
        http: {
            get () {
                return axios;
            }
        },
        api: {
            get () {
                return apiGateway;
            }
        }
    });

    Object.defineProperties(Vue, {
        http: {
            get () {
                return axios;
            }
        }
    });
}
